import Grid from './grid';
import defaultsDeep from 'lodash-es/defaultsDeep';
import isFunction from 'lodash-es/isFunction';
import get from 'lodash-es/get';
import uniqBy from 'lodash-es/uniqBy';
import remove from 'lodash-es/remove';
// import lookAndFeel from '../lookAndFeel';

const dropBoxIcons = {
  dropbox:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z' /%3E%3C/svg%3E",
  upload:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M16 18H18V22H20V18H22L19 15L16 18Z' /%3E%3C/svg%3E",
  download:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8M20 16H18V20H16L19 23L22 20H20V16Z' /%3E%3C/svg%3E",
  upload_and_download:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M13 19C13 19.34 13.04 19.67 13.09 20H4C2.9 20 2 19.11 2 18V6C2 4.89 2.89 4 4 4H10L12 6H20C21.1 6 22 6.89 22 8V13.81C21.39 13.46 20.72 13.22 20 13.09V8H4V18H13.09C13.04 18.33 13 18.66 13 19M22 20V16H20V20H18.5L21 23L23.5 20H22M17 15L14.5 18H16V22H18V18H19.5L17 15Z' /%3E%3C/svg%3E",
  folder:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z' /%3E%3C/svg%3E",
  file:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z' /%3E%3C/svg%3E",
  parent_folder:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M20 18V20H13.5C9.91 20 7 17.09 7 13.5V7.83L3.91 10.92L2.5 9.5L8 4L13.5 9.5L12.09 10.91L9 7.83V13.5C9 16 11 18 13.5 18H20Z' /%3E%3C/svg%3E",
  actionDownload: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z' /%3E%3C/svg%3E",
  actionOpen: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M6.1,10L4,18V8H21A2,2 0 0,0 19,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H19C19.9,20 20.7,19.4 20.9,18.5L23.2,10H6.1M19,18H6L7.6,12H20.6L19,18Z' /%3E%3C/svg%3E",
  actionUpload: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z' /%3E%3C/svg%3E",
  actionReload: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z' /%3E%3C/svg%3E",
  actionDelete: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z' /%3E%3C/svg%3E",
};
          
export default class DropBox extends Grid {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this,'entries',[]);
    this.addApi(this, 'currentPath', () => this._controlOptions.currentPath||'',{onChange: (newPath,oldPath)=>{
      if(newPath!==oldPath){
        this.reload();
      }
    }});
    this.icons = dropBoxIcons;
    instance.on('ready',()=>this.reload());
  }

  whenToInit(){
    this.on('entries',()=>{
      this.once('render',()=>{
        this.fire('init');
      });
    });
  }

  onReady(){

    super.onReady();
    
    this.on('anchor',()=>{
      if(this.anchor){
        const $id = get(this.anchor,'record.$id');
        if($id!==undefined){
          this.anchor.entry = this.entries.find(e => e.$id === $id);
        }        
      }
    });
    this.on('dragover',(event,ctrl,cmp,anchor,[ev])=>{
      ev.preventDefault();     
      if(this.viewMode!='tree' &&this.canUpload()){
        this.isDragOver = true;
        this.render();        
      } else {
        return false;        
      }
    });

    
    this.on('drop',(event,ctrl,cmp,anchor,[ev])=>{
      ev.preventDefault();
      if(this.viewMode!='tree' && this.canUpload() && ev.dataTransfer.files[0]){
        this.upload(ev.dataTransfer.files[0]);
      }
      
      this.isDragOver = false;
      this.render();
      
    });

    this.on('dragleave,dragend',(event,ctrl,cmp,anchor,[ev])=>{
      ev.preventDefault();
      if(this.viewMode!='tree'){
        this.isDragOver = false;
        setTimeout(()=>{
          if(!this.isDragOver){
            this.render();          
          }
        },100);        
      }
    });

    this.on('click,dblclick',(event,ctrl,cmp,anchor,[ev])=>{
      if(this._controlOptions.navigateFolders!=='off' && anchor && anchor.entry){
        if(this._controlOptions.navigateFolders=='click'&& ev.type=='click' ||
          this._controlOptions.navigateFolders=='doubleClick' && ev.type=='dblclick'){
           this.open(anchor.entry);
        }
      }
    });

  }

  renderElement() {
    // console.log('renderDropBox', control, options, instance, path);
    this._controlOptions = defaultsDeep(this._controlOptions, {
      dropBoxName:'',
      navigateFolders:'doubleClick',
      dropBoxIcons
    });

    return super.renderElement();
  }

  canDownload(entry){
    return !!(entry && entry.isFile && (entry.type=='DOWNLOAD'||entry.type=='UPLOAD_AND_DOWNLOAD'));
  }

  download(entry){
    return this.instance.dropBoxDownload(entry);
  }

  canOpen(entry){
    return !!entry && (!entry.isFile||this.canDownload(entry));
  }

  fetchParentEntry(path){
    let p = path.split('/');
    if(!p.length){return null;}

    const name = p[p.length-1]
    p.pop();
    p = p.join('/');
    return this.instance.dropBoxList(this._controlOptions.dropBoxName+'/'+p).then(data => data.find(entry => entry.name === name));
  }

  open(entry){
    const p = entry.path.split('/');
    p.shift();
    if(!entry.isFile){
      if(entry.name=='..'){
        p.pop();
        this.currentPath = p.join('/');
      }else{
        if(!entry.isOpened){
          entry.isOpened=true;
          if(entry.path){
            this.currentPath = p.join('/')+'/'+entry.name;
          }else{
            this.currentPath = entry.name;
          }          
        }else{
          entry.isOpened=false;
          remove(this.entries, e => e.path==entry.fullPath);
          this.instance.setExtData('dropbox',this._controlOptions.name,{DropBox:{entries:this.entries}});
          p.pop();
          this.currentPath = p.join('/');
        }
      }
    }else if(entry.type=='DOWNLOAD' || entry.type=='UPLOAD_AND_DOWNLOAD'){
      window.open(this.instance.dropBoxGetFileUrl(entry),'_blank');
    }
  }

  canUpload(){
    return !!(this.parentEntry && !this.parentEntry.isFile && (this.parentEntry.type=='UPLOAD'||this.parentEntry.type=='UPLOAD_AND_DOWNLOAD'));
  }

  upload(file){
    this.instance.spinner.show({text:'Uploading...'});
    return this.instance.dropBoxUpload(this._controlOptions.dropBoxName+'/'+this.currentPath, file, (progress)=>{
      this.instance.spinner.show({text:'Uploading: '+progress+'%', showSpinner:false});
    })
    .then((entry)=>{      
      if(entry){
        this.instance.spinner.hide();
        this.reload();
      }
    })
    ['catch'](ex => {
      this.instance.spinner.hide();      
      this.reload();
      console.log(ex);
      alert("Upload failed. Make sure you're uploading single file, not folder.");
    });
  }

  canDelete(entry){
    return !!(entry && entry.path && entry.path!== this._controlOptions.dropBoxName && (entry.type=='UPLOAD' || entry.type=='UPLOAD_AND_DOWNLOAD'));
  }

  delete(entry){
    return this.instance.dropBoxDelete(entry).then(()=>this.reload());
  }

  reload(){
    this.parentEntry = null;
    if(!this._controlOptions.dropBoxName){
      this.error = 'Option "dropBoxName" is empty';
      this.entries = [];
      this.instance.setExtData('dropbox',this._controlOptions.name,{DropBox:{entries:[]}});
      this.instance.refresh();
      return;
    }

    this.error='';
    this.baseId = this._controlOptions.dropBoxName;

    const promises = [];
    if(this.viewMode=='tree'){
      const path = this.currentPath.split('/');
      while(path.length){
        promises.push(this.instance.dropBoxList(this._controlOptions.dropBoxName+'/'+path.join('/')));
        path.pop();
      }
    }else{
      promises.push(this.instance.dropBoxList(this._controlOptions.dropBoxName+'/'+this.currentPath));
    }

    Promise.all(promises).then(data=>{
      data = data.flat();

      if(this.viewMode!=='tree'&&this._controlOptions.navigateFolders!=='off'&&this.currentPath&&this.currentPath!=='/'){
        data.unshift({          
          name: '..',
          lastModified: '',
          expiration: 0,
          isDropBox: false,
          isFile: false,
          maxSize: 0,
          organizations: '',
          owner: '',
          path: this.currentPath,
          size: 0,
          type: '',
          icon: 'parent_folder',
          extension:'',
          fullPath: this.currentPath+'/..',
        });
      }

      data.forEach(entry => {
        entry.$id = entry.path+'/'+entry.name;        
        var libicon = _.find(this.instance.options.icons, ['name', entry.icon]);
        if (!libicon && this._controlOptions.dropBoxIcons[entry.icon]) {
          entry.icon = this._controlOptions.dropBoxIcons[entry.icon];
        }
      });
      if(this.entries&&this.viewMode=='tree'){
        data = uniqBy([...data,...this.entries],'$id');
      }

      this.entries = data;
      this.instance.setExtData('dropbox',this._controlOptions.name,{DropBox:{entries:data}});
      this.instance.refresh();
      this.fetchParentEntry(this.currentPath).then(entry => {
        this.parentEntry = entry;
      });
    },reason => {
      this.error=reason.message||reason;
      this.entries = [];
      this.instance.setExtData('dropbox',this._controlOptions.name,{DropBox:{entries:[]}});
      this.instance.refresh();
    });
  }
}
